import { QTD_DEPENDENTES_ENUM } from '../helpers/funcoesPadroes';

const parentescosPermitidosZeloPrimeE1 = [
    '01', '02', '10', '10006', '5', '20007', '20008', '50'
];
export const IDADE_ENUM = {
    sessentaCinco: 65,
    setentaCinco: 75
};

export const validatorPossui2Dependentes75anos = (dependentes, valoresForm, idadeAssociado) => {
    const arrayDeValidacoes = [
        idadeAcima75(valoresForm.Idade),
        calcularQuantidadeDependentes75anos(dependentes, idadeAssociado, valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const calcularQuantidadeDependentes75anos = ((dependentes, idadeAssociado, categoria) => {
    let qtdDependentes = dependentes.filter(dep => dep.Idade >= 75 && dep['CategoriaParentesco.Categoria'] === 'ZELO').length;

    if (idadeAssociado >= 75) {
        qtdDependentes = qtdDependentes + 1;
    }

    if (categoria === 'ZP26') {
        return qtdDependentes === 3 ? true : false;
    }

    return qtdDependentes === 2 ? true : false;
});

export const calcularQtdDependentesPet = dependentes => {
    const qtdPets = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau']?.trim() === 'PET'
    ).length;

    return qtdPets;
};

export const idadeAcima75 = idade => idade >= IDADE_ENUM.setentaCinco;

export const verificaCondicaoAteLimiteDependentes = (qtdTotalDependentes, qtdDependentesPet, valoresForm) => qtdTotalDependentes < 4 &&
    qtdDependentesPet <= 3 &&
    valoresForm.Parentesco?.trim() === 'PET' &&
    valoresForm.Categoria?.trim() === 'ZP26';

export const verificaCondicaoExcedeLimiteDependentes = (qtdTotalDependentes, qtdDependentesPet, valoresForm) => qtdTotalDependentes >= 4 &&
    qtdDependentesPet <= 3 &&
    valoresForm.Categoria?.trim() !== 'ZPETA' &&
    valoresForm.Parentesco?.trim() === 'PET';

export const verificaQuantidadePetSemValorAdicional = (dependentes, valoresForm) => {
    let petsSemValorAdicional = 0;

    if (valoresForm.Parentesco === 'PET' && valoresForm.Categoria === 'ZELO') {
        petsSemValorAdicional = dependentes.filter(dependente =>
            dependente.Categoria === 'ZELO' &&
            dependente.Parentesco === 'PET (ANIMAL)'
        ).length;
    }

    return petsSemValorAdicional >= 4;
};

export const verificarGrauParentescoRepetidos = (dependentes, parentesco) => {
    const parentescosQuePodemSerMaisQueUm = ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24', 'PET', 'AVô'];

    const parentescoForm = parentesco.trim();

    if (parentescosQuePodemSerMaisQueUm.includes(parentescoForm)) {
        return false;
    }

    const dependentesQtd = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau']?.trim() !== ''
    );

    const grausParentesco = new Set(dependentesQtd
        .filter(dependente => !parentescosQuePodemSerMaisQueUm.includes(dependente['GrauParentesco.Grau'].trim()))
        .map(dependente => dependente['GrauParentesco.Grau'].trim())
    );

    const parentescoJaExiste = grausParentesco.has(parentescoForm);

    return parentescoJaExiste;
};

export const verificarIdadeMembros = (dependentes, idadeAssociado) => {
    const qtdDependentesHumanos = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau']?.trim() !== 'PET'
    ).length;

    return qtdDependentesHumanos;
};

export const calcularQtdDependentesHumanos = dependentes => {
    const qtdDependentesHumanos = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau']?.trim() !== 'PET'
    ).length;

    return qtdDependentesHumanos;
};

export const calcularQtdDependentesEspeciaisHumanos = dependentes => {
    const qtdDependentesHumanos = dependentes.filter(
        dependente => dependente['CategoriaParentesco.Categoria']?.trim() === 'ZP26' && dependente['GrauParentesco.Grau']?.trim() !== 'PET'
    ).length;

    return qtdDependentesHumanos;
};

export const calcularQtdTotalDependentes = dependentes => {
    const qtdDependentesTotal = dependentes.filter(
        dependente => dependente['CategoriaParentesco.Categoria']?.trim() === 'ZP26' || dependente['CategoriaParentesco.Categoria']?.trim() === 'ZELO' || dependente['CategoriaParentesco.Categoria']?.trim() === 'ZPETA'
    ).length;

    return qtdDependentesTotal;
};

export const verificarParentescoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidosZeloPrimeE1.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? true : false;
};

const verificarParentescoNaoPermitido = parentesco => {
    const parentescoEncontrado = parentescosPermitidosZeloPrimeE1.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado !== undefined ? false : true;
};

const verificarComAdicional = categoria => categoria === 'ZP26';
const verificarSemAdicional = categoria => categoria === 'ZELO';
const verificarParentescoPet = parentesco => parentesco !== 'PET';
const verificarParentescoVazio = parentesco => parentesco !== '';

export const verificarParentescoForaDaEstruturaIlimitada = dependentes => {
    const qtdDepPrimeE1 = dependentes.filter(
        dependente => dependente['CategoriaParentesco.Categoria']?.trim() === 'ZELO' &&
            verificarParentescoNaoPermitido(dependente['GrauParentesco.Grau'].trim())
    ).length;

    return qtdDepPrimeE1 >= 1 ? true : false;
};

const verificar1DependentesComValorAdicional = dependentes => {
    const qtdDependentesHumanos = dependentes.filter(dependente => {
        const categoria = dependente['CategoriaParentesco.Categoria']?.trim() || dependente.Categoria;
        const grauParentesco = dependente['GrauParentesco.Grau']?.trim() != 'PET';

        return categoria === 'ZP26' && grauParentesco;
    }).length;

    return qtdDependentesHumanos === 1;
};

export const verificarQtdDependentesSemAdicional = dependentes => {
    const qtdDependentes = dependentes.filter(dependente => {
        const categoria = dependente['CategoriaParentesco.Categoria']?.trim() || dependente.Categoria;

        return categoria === 'ZELO';
    }).length;

    return qtdDependentes >= 4;
};

export const verificarQtdDependentesSemAdicionalE1 = dependentes => {
    const dependentesNaoPermitidos = dependentes.filter(dependente =>
        !parentescosPermitidosZeloPrimeE1.includes(dependente['GrauParentesco.Grau'].trim())
    );

    return dependentesNaoPermitidos.length >= 4;
};

export const verificarQtdDependentesComAdicional = dependentes => {
    const qtdDependentesHumanos = dependentes.filter(
        dependente => dependente['CategoriaParentesco.Categoria']?.trim() !== 'ZELO'
    ).length;

    return qtdDependentesHumanos !== 0;
};

export const verificarQtd5Dependentes = dependentes => {
    const qtdDependentesHumanos = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau']?.trim() !== 'PET'
    ).length;

    return qtdDependentesHumanos >= 5 ? true : false;
};

export const verificarQtd4Dependentes = dependentes => {
    const qtdDependentesHumanos = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau']?.trim() !== 'PET'
    ).length;

    return qtdDependentesHumanos >= 4 ? true : false;
};

export const validatorMaximo1DepComValorAdicional = (dependentes, valoresForm) => {
    const arrayDeValidacoes = [
        verificarParentescoVazio(valoresForm.Parentesco.trim()),
        verificarParentescoPet(valoresForm.Parentesco.trim()),
        verificarComAdicional(valoresForm.Categoria.trim()),
        verificar1DependentesComValorAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDepPrimeE1 = (dependentes, valoresForm) => {
    const arrayDeValidacoes = [
        verificarParentescoPermitido(dependentes),
        verificarParentescoVazio(valoresForm.Parentesco.trim()),
        verificarParentescoPet(valoresForm.Parentesco.trim()),
        verificarSemAdicional(valoresForm.Categoria.trim()),
        verificarQtdDependentesSemAdicional(dependentes),
        verificarParentescoForaDaEstruturaIlimitada(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDepPrimeE2 = (dependentes, valoresForm) => {
    const arrayDeValidacoes = [
        verificarParentescoVazio(valoresForm.Parentesco.trim()),
        verificarParentescoPet(valoresForm.Parentesco.trim()),
        verificarSemAdicional(valoresForm.Categoria.trim()),
        verificarParentescoNaoPermitido(valoresForm.Parentesco.trim()),
        verificarQtdDependentesSemAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorEstrutura2JaCompletada = (dependentes, valoresForm) => {
    const arrayDeValidacoes = [
        verificarParentescoVazio(valoresForm.Parentesco.trim()),
        verificarParentescoPet(valoresForm.Parentesco.trim()),
        verificarQtdDependentesSemAdicional(dependentes),
        verificarQtdDependentesComAdicional(dependentes)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const comparaRegrasDepAtuaisComDepUpSell = (dependentes, idadeAssociado) => {
    const contagemCategoriaExistente = {
        ZELO: 0,
        OUTRASCATEGORIAS: 0,
        ACIMA75: 0
    };

    const limitCategoriaZELO = 4;
    const limitCategoriaEspecial = QTD_DEPENDENTES_ENUM.um;
    const limiteMaximoAcima75 = idadeAssociado > IDADE_ENUM.setentaCinco ? QTD_DEPENDENTES_ENUM.um : QTD_DEPENDENTES_ENUM.dois;

    for (const dep of dependentes) {
        const categoria = dep.Categoria;
        const idadeDependente = dep['Idade'];
        const seq = dep.Seq;
        const parentesco = dep['GrauParentesco.Grau'];

        if (categoria === 'ZELO') {
            parentescosPermitidosZeloPrimeE1.push('PET');

            if (!parentescosPermitidosZeloPrimeE1.includes(parentesco)) {
                return `Categoria na seq: ${seq} inválida para o tipo de parentesco.`;
            }

            contagemCategoriaExistente.ZELO++;
        } else if (categoria === 'ZP26') {
            contagemCategoriaExistente.OUTRASCATEGORIAS++;
        } else if (categoria !== 'ZPETA') {
            return `A categoria do dependente na seq: ${seq} esta icorreta para este plano.`;
        }

        if (idadeDependente > IDADE_ENUM.sessentaCinco) {
            contagemCategoriaExistente.ACIMA75++;
        }
    }

    if (contagemCategoriaExistente.ZELO > limitCategoriaZELO) {
        return `Limite de dependentes ZELO excedido. Limite permitido: ${limitCategoriaZELO}; encontrado: ${contagemCategoriaExistente.ZELO}.`;
    }

    if (contagemCategoriaExistente.OUTRASCATEGORIAS > limitCategoriaEspecial) {
        return `Limite de dependentes especial excedido. Limite permitido: ${limitCategoriaEspecial}, encontrado: ${contagemCategoriaExistente.OUTRASCATEGORIAS}.`;
    }

    if (contagemCategoriaExistente.OUTRASCATEGORIAS > 0 && contagemCategoriaExistente.ZELO > limitCategoriaZELO) {
        return `Limite de dependentes ZELO excedido. Limite permitido: ${limitCategoriaZELO}; encontrado: ${contagemCategoriaExistente.ZELO}.`;
    }

    if (contagemCategoriaExistente.ACIMA75 > limiteMaximoAcima75) {
        return `Limite de dependentes acima de 64 anos excedido, é permitido até ${limiteMaximoAcima75} dependente e foram encontrado: ${contagemCategoriaExistente.ACIMA75}.`;
    }
};
